import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import TextField from 'components/TextField'
import SearchField from 'components/SearchField'
import Button from 'components/buttons/Button'
import PageControl from 'components/PageControl'

import Modal from 'components/Modal'

import SectionWithHeader from 'layout/SectionWithHeader'

import { AddEmployeeForm, EditEmployeeForm, DeleteEmployeeForm } from 'forms/Employee'
import EmployeeList from 'lists/EmployeesList'

import EmployeesAPI from 'api/EmployeesAPI'


import styles from './index.css'

@withRouter
export default class Employee extends React.Component {
  
  static propTypes = {
  }

  PAGE_SIZE = 25

  


  constructor(props) {
    super(props)
    this.fetchEmployees = this.fetchEmployees.bind(this)

    const { search, page } = JSON.parse(window.sessionStorage["employee_list"] || '{}')

    this.state = {
      modal : null,
      employees: [],
      total: 0,
      page: page || 1,
      search: search || '',
      skip: 0,
      limit: this.PAGE_SIZE
    }

  }


  async fetchEmployees({search, skip, limit}) {
    this.setState({ loading : true })
    const { response } = await EmployeesAPI.list({
      search, skip, limit
    })
    if (response) {
      this.setState({ 
        total: response.total,
        employees: response.results 
      })
    }
    this.setState({ loading: false })
  }

  componentDidUpdate(prevProps, prevState) {
    let fetchNeeded = false
    if (prevState.page !== this.state.page) {
      fetchNeeded = true
    }
    if (prevState.search !== this.state.search) {
      fetchNeeded = true
    }
    if (fetchNeeded) {
      window.sessionStorage["employee_list"] = JSON.stringify({ 
        search: this.state.search, 
        page  : this.state.page
      })
      this.fetchEmployees({
        search: this.state.search,
        skip: (this.state.page-1) * this.PAGE_SIZE,
        limit: this.PAGE_SIZE
      })
    }
  }

  componentDidMount() {
    this.fetchEmployees(this.state)
  }

  render() {
    return (
      <div className={styles.Page}>
        <Modal open={'EMPLOYEE_ADD' == this.state.modal}>
          <AddEmployeeForm 
            onClose={() => this.setState({ modal : null }) } 
            onSubmitted={ this.fetchEmployees }
            />
        </Modal>
        
        <Modal open={'EMPLOYEE_EDIT' == this.state.modal}>
          <EditEmployeeForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={ this.fetchEmployees }
            />
        </Modal>

        <Modal open={'EMPLOYEE_DELETE' == this.state.modal}>
          <DeleteEmployeeForm 
            id={this.state.entityId}
            onClose={() => this.setState({ modal : null })} 
            onSubmitted={ this.fetchEmployees }
            />
        </Modal>

        <SectionWithHeader
          title={"Users"}
          headerChildren={
            <div style={{display: 'flex', alignItems: 'center' }}>
              <div style={{paddingRight: '1rem'}}>
                <SearchField 
                  placeholder='Search user' 
                  defaultValue={this.state.search}
                  onChange={search => this.setState({ search })}
                  />
              </div>
              <Button
                fullWidth={false}
                onClick={() => this.setState({ modal: 'EMPLOYEE_ADD' })}>
                Add User
              </Button>
            </div>
          }>
          <EmployeeList 
            loading={this.state.loading}
            entities={this.state.employees}
            onEdit={id => this.setState({ modal: 'EMPLOYEE_EDIT', entityId: id })}
            onDelete={id => this.setState({ modal: 'EMPLOYEE_DELETE', entityId: id })}
            pageControl={
              <PageControl 
                page={this.state.page}
                numPages={Math.ceil(this.state.total / this.PAGE_SIZE)}
                onChange={page => this.setState({ page })} />
            }
            />
        </SectionWithHeader>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Employees/index.jsx